module.exports = __webpack_public_path__ + "7b071584917c2abc37dd509f6bf54fa8-phone_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/resources/assets/phone_2x.png
// module id = 774
// module chunks = 0